(() => {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const visible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    const st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width > 100 && r.height > 20;
  };

  const findHeading = () =>
    [...document.querySelectorAll('h1, h2, h3')]
      .filter(visible)
      .find((el) => norm(el.textContent) === 'designed with purpose');

  const findSection = (heading) => {
    let node = heading;
    while (node && node !== document.body) {
      if (node.matches?.('section')) return node;
      node = node.parentElement;
    }
    return heading.closest('.shopify-section') || heading.parentElement;
  };

  const findHeaderBlock = (heading, section) => {
    let node = heading.parentElement;
    let candidate = node;

    while (node && node !== section) {
      const r = node.getBoundingClientRect();
      if (r.width >= section.getBoundingClientRect().width * 0.55 && r.height < 360) {
        candidate = node;
      }
      node = node.parentElement;
    }
    return candidate;
  };

  const findGrid = (section, headerBlock) => {
    const candidates = [...section.querySelectorAll('*')]
      .filter((el) => {
        if (!(el instanceof HTMLElement)) return false;
        if (headerBlock && headerBlock.contains(el)) return false;
        const r = el.getBoundingClientRect();
        if (r.width < section.getBoundingClientRect().width * 0.65) return false;
        if (r.height < 180 || r.height > 500) return false;

        const children = [...el.children].filter(visible);
        return children.length >= 4 && children.length <= 8;
      })
      .sort((a, b) => {
        const ar = a.getBoundingClientRect();
        const br = b.getBoundingClientRect();
        return (br.width * br.height) - (ar.width * ar.height);
      });

    return candidates[0] || null;
  };

  const apply = () => {
    const heading = findHeading();
    if (!heading) return;

    const section = findSection(heading);
    if (!section) return;

    section.classList.add('elizna-purpose-spacing-v1');

    const headerBlock = findHeaderBlock(heading, section);
    if (headerBlock) {
      headerBlock.classList.add('elizna-purpose-spacing-v1__header');
    }

    let inner = heading;
    while (inner.parentElement && inner.parentElement !== section) {
      inner = inner.parentElement;
    }
    if (inner && inner !== heading) {
      inner.classList.add('elizna-purpose-spacing-v1__inner');
    }

    const grid = findGrid(section, headerBlock);
    if (grid) {
      grid.classList.add('elizna-purpose-spacing-v1__grid');
    }
  };

  const schedule = () => requestAnimationFrame(apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
